// Backend `timestamp without time zone` columns serialize as naive ISO strings
// that are UTC. Without an explicit offset, `new Date()` reads them as local time.
const HAS_TZ_DESIGNATOR = /(Z|[+-]\d{2}:?\d{2})$/i;

export function parseServerDate(value: string | null | undefined): Date | null {
  if (!value) return null;
  const trimmed = value.trim();
  const isDateTime = trimmed.includes('T') || trimmed.includes(' ');
  const iso = isDateTime && !HAS_TZ_DESIGNATOR.test(trimmed)
    ? `${trimmed.replace(' ', 'T')}Z`
    : trimmed;
  const date = new Date(iso);
  return Number.isNaN(date.getTime()) ? null : date;
}

export function formatServerDate(value: string | null | undefined, language: string): string {
  const date = parseServerDate(value);
  if (!date) return '';
  return date.toLocaleDateString(language === 'tr' ? 'tr-TR' : 'en-US', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  });
}
